// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartOutlinedSvg from "@ant-design/icons-svg/es/asn/PieChartOutlined";
import AntdIcon from '../components/AntdIcon';

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
export default React.forwardRef(PieChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PieChartOutlined.js
// module id = 1573
// module chunks = 0